import "./quickAccess.scss";
import QuickAccessItem from "./QuickAccessItem";

function QuickAccess({ title = "دسترسی سریع", items = [] }) {
  return (
    <section
      className="QuickAccess"
      dir="rtl"
      aria-label={title}
    >
      <h3 className="QuickAccess__title">{title}</h3>
      <div className="QuickAccess__grid">
        {items.map((item) => (
          <QuickAccessItem
            key={item.to + item.label}
            to={item.to}
            label={item.label}
            Icon={item.Icon}
            ariaLabel={item.ariaLabel || item.label}
          />
        ))}
      </div>
    </section>
  );
}

export default QuickAccess;
